import { Navigate, useParams } from "react-router-dom";

export const ParamRedirect = ({ to }) => {
  const params = useParams();

  let finalPath = to;
  Object.entries(params).forEach(([key, value]) => {
    finalPath = finalPath.replace(`:${key}`, value);
  });

  return <Navigate to={finalPath} replace />;
};
